module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-25-865a9e77838fe510a44c5cf2164d21f7.png";